export const routes = {
  dashboard: '/dashboard',
  login: process.env.REACT_APP_MSAL_AUTHORITY_SIGNUP_SIGNIN || '',
  appointment: '/prendre-rendez-vous'
};

export const routesNested = {
  resume: `${routes.dashboard}/resume`,
  appointment: {
    connectionStep: `${routes.appointment}/connexion`
  }
};
